export default "__VITE_ASSET__gVvTQuFr__"